export const processWhiteList = {
  "1-3-3": "1-3-5",
  "2-2-4": "2-2-7",
  "2-3-2": "2-3-5",
}
export const ProcessStatus = {
  '1': {first:'IndividualA', last: 'IndividualL'},
  '2': {first:'SolePropA', last: 'SolePropM'},
  '3': {first:'CorporationA', last: 'CorporationL'},
  '4': {first:'PartnershipA', last: 'PartnershipL'},
  '5': {first:'BdoMerchantA', last: 'BdoMerchantB'},
}